import {SisName} from 'util/SisName';
import {SisNameUrl} from 'util/SisNameUrl';

export const ET_BOOKING = SisName.Booking;
export const ET_BOOKING_URL = SisNameUrl[SisName.Booking];

export const ET_PERSURL = SisName.Persurl;
export const ET_PERSURL_URL = SisNameUrl[SisName.Persurl];

export const EntityAttributes = {
	[SisName.Persurl]: ['id', 'persNr', 'start', 'end', 'hourCategory', 'openMarking', 'representative', 'altRepresentative', 'text', 'cf'],
	[SisName.Booking]: ['bookingNr', 'persNr', 'bookingDate', 'bookingTime', 'bookingTimespan', 'bookingType', 'hourCategory', 'bewEinh', 'empfEinh', 'einstuf', 'stKey', 'stTagKey', 'empfArt', 'einstufArt', 'gruppeKz', 'text', 'mdat', 'cf', 'rfid'],
	[SisName.StTagZu]: ['persNr', 'date', 'soll', 'normalBegin', 'normalEnd', 'kernBegin', 'kernEnd', 'glzBegin', 'glzEnd'],
	[SisName.PlanTempl]: ['planTag', 'bookingTime', 'bookingTimespan', 'bookingType', 'hourCategory', 'bewEinh', 'empfEinh', 'stKey', 'stTagKey', 'text'],
} as const

export const WorkflowChangeableFields = ['text'];
